import { store } from '@/store'
import { getCardDetail } from '@/api-service'

/**
 * Card-detail modal openers — one global modal (mounted in App.vue, driven by
 * store.card_detail) so a tarot card can be inspected from ANY reading surface.
 */

// Show immediately from a card object that already carries the data
// (e.g. SeekerModal's reading_preview cards have card_meaning + reader_symbolism).
export function showCardDetail(card) {
  if (card) store.card_detail = card
}

// Fetch + show when the surface only knows the reader + card identity
// (live reading, Studio preview). Falls back silently if the lookup fails.
export async function openCardDetailFor({ reader, card, reversed = false, position = '' }) {
  if (!card) return
  const data = await getCardDetail(reader, card, reversed)
  if (data) store.card_detail = { ...data, position }
}

export function closeCardDetail() {
  store.card_detail = null
}
